(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ms-brands-menu"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-brands-menu')) {
    customElements.define('ms-brands-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
        const input = this.querySelector('.ms-brands__search');
        const list = this.querySelector('.ms-brands__list');
        const empty = this.querySelector('.ms-brands__empty');
        const alphabet = this.querySelector('.ms-brands__alphabet');
        const buttons = Array.from(alphabet.querySelectorAll('button'));
        const entries = Array.from(list.querySelectorAll('[data-brand-name]')).map(item => {
          const name = normalize(item.dataset.brandName);
          const initials = item.dataset.brandName.split(/\s+/).map(word => normalize(word).charAt(0)).join('');
          return { item, name, initials, letter: /^[a-z]/.test(name) ? name.charAt(0).toUpperCase() : '#' };
        });
        const filter = () => {
          const query = normalize(input.value);
          entries.forEach(entry => { entry.item.hidden = !entry.name.includes(query) && !entry.initials.startsWith(query); });
          empty.hidden = entries.some(entry => !entry.item.hidden);
          buttons.forEach(button => { button.disabled = !entries.some(entry => !entry.item.hidden && entry.letter === button.dataset.letter); });
          list.scrollTop = 0;
        };
        input.addEventListener('input', filter);
        input.addEventListener('keydown', event => {
          if (event.key !== 'ArrowDown') return;
          const first = entries.find(entry => !entry.item.hidden);
          if (first) { event.preventDefault(); first.item.querySelector('a').focus(); }
        });
        buttons.forEach(button => button.addEventListener('click', () => {
          const entry = entries.find(item => !item.item.hidden && item.letter === button.dataset.letter);
          if (!entry) return;
          const target = entry.item.querySelector('a');
          list.scrollTop += target.getBoundingClientRect().top - list.getBoundingClientRect().top;
          target.focus({ preventScroll: true });
        }));
        this.addEventListener('keydown', event => {
          if (event.key !== 'Escape') return;
          event.preventDefault(); event.stopPropagation();
          const owner = this.closest('.navigation__item');
          owner.dispatchEvent(new Event('mouseleave'));
          const trigger = owner.querySelector(':scope > .navigation__link');
          const proxy = Array.from(document.querySelectorAll('#proxy-nav .navigation__link')).find(link => link.getAttribute('aria-controls') === trigger.getAttribute('aria-controls'));
          const visibleProxy = proxy?.getClientRects().length && getComputedStyle(proxy).visibility === 'visible';
          (visibleProxy ? proxy : trigger).focus({ preventScroll: true });
        });
        filter();
        alphabet.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-cart-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-cart-recommendations')) {
    customElements.define('ms-cart-recommendations', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.load();
      }

      async load() {
        const list = this.querySelector('[data-mini-list]');
        if (!list) return;
        try {
          const excluded = new Set(JSON.parse(this.dataset.excludedProducts).map(String));
          let rows = Array.from(list.children);
          if (this.dataset.url) {
            const response = await fetch(this.dataset.url, { signal: this.controller.signal });
            if (!response.ok) throw new Error('Recommendations unavailable');
            const html = await response.text();
            const documentFragment = new DOMParser().parseFromString(html, 'text/html');
            rows = Array.from(documentFragment.querySelectorAll('[data-ms-mini-results] > [data-mini-product]'));
          }
          if (!this.isConnected || this.controller.signal.aborted) return;
          const seen = new Set(excluded);
          const visibleRows = rows.filter(row => {
            const id = row.dataset.miniProduct;
            if (!id || seen.has(id)) return false;
            seen.add(id);
            return true;
          }).slice(0, 3);
          list.replaceChildren(...visibleRows.map(row => row.cloneNode(true)));
          this.hidden = visibleRows.length === 0;
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }

      disconnectedCallback() {
        this.controller?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-product-share"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-product-share')) {
  customElements.define('ms-product-share', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.toggle = this.querySelector('summary');
      this.link = this.querySelector('[data-share-link]');
      this.status = this.querySelector('[data-share-status]');
      this.copy = this.querySelector('[data-share-copy]');
      this.native = this.querySelector('[data-share-native]');
      this.events = new AbortController();
      const options = { signal: this.events.signal };

      this.copy.hidden = false;
      this.native.hidden = typeof navigator.share !== 'function';
      this.copy.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(this.dataset.url);
          this.status.textContent = this.dataset.copied;
        } catch {
          this.link.focus();
          this.link.select();
          this.status.textContent = this.dataset.manual;
        }
      }, options);
      this.native.addEventListener('click', async () => {
        try {
          await navigator.share({ title: this.dataset.title, url: this.dataset.url });
        } catch (error) {
          if (error.name !== 'AbortError') {
            this.link.focus();
            this.link.select();
            this.status.textContent = this.dataset.manual;
          }
        }
      }, options);
      this.details.addEventListener('toggle', () => {
        if (!this.details.open) this.status.textContent = '';
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          this.details.open = false;
          this.toggle.focus();
        }
      }, options);
      document.addEventListener('click', (event) => {
        if (this.details.open && !this.contains(event.target)) this.details.open = false;
      }, options);
    }

    disconnectedCallback() {
      this.events?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-quickbuy-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-selected-size')) {
  customElements.define('ms-selected-size', class extends HTMLElement {
    connectedCallback() {
      this.productRoot = this.closest('.product-form');
      this.valueElement = this.querySelector('[data-ms-size-value]');
      this.optionIndex = Number(this.dataset.optionPosition) - 1;
      if (!this.productRoot || !this.valueElement || this.optionIndex < 0) return;

      this.onVariantChange = (event) => {
        const options = event.detail?.selectedOptions || event.detail?.variant?.options;
        if (options) this.setSize(options[this.optionIndex]);
      };
      this.productRoot.addEventListener('on:variant:change', this.onVariantChange);

      // Swatch King's cards are inserted asynchronously and expose their selection via ARIA.
      this.observer = new MutationObserver(() => this.syncSwatches());
      this.observer.observe(this.productRoot, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['aria-checked']
      });
      this.syncSwatches();
    }

    setSize(value) {
      if (typeof value === 'string' && this.valueElement.textContent !== value) {
        this.valueElement.textContent = value;
      }
    }

    syncSwatches() {
      const labelId = `option${this.optionIndex + 1}`;
      const group = this.productRoot.querySelector(`[role="radiogroup"][aria-labelledby="${labelId}"]`);
      const selected = group?.querySelector('[role="radio"][aria-checked="true"]');
      if (!selected) return;
      this.setSize(selected.getAttribute('aria-label'));
      const label = this.productRoot.querySelector(`[id="${labelId}"]`)?.closest('label');
      if (label) label.setAttribute('data-ms-size-label', '');
    }

    disconnectedCallback() {
      this.productRoot?.removeEventListener('on:variant:change', this.onVariantChange);
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ms-size-assist"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ms-size-assist')) {
    customElements.define('ms-size-assist', class extends HTMLElement {
      connectedCallback() {
        this.root = this.closest('.product-form');
        if (!this.root) return;
        this.sizeIndex = Number(this.dataset.sizeIndex);
        this.status = this.querySelector('[role="status"]');
        this.queueSync = () => {
          if (this.syncPending) return;
          this.syncPending = true;
          queueMicrotask(() => {
            this.syncPending = false;
            if (this.isConnected) this.sync();
          });
        };
        this.onClick = event => {
          const button = event.target.closest('[data-size-choice]');
          if (button && this.contains(button) && !button.disabled) this.choose(Number(button.dataset.sizeChoice));
        };
        this.addEventListener('click', this.onClick);
        this.root.addEventListener('on:variant:change', this.queueSync);
        this.root.addEventListener('change', this.queueSync);
        this.observer = new MutationObserver(records => {
          if (records.some(record => !record.target.closest('ms-size-assist'))) this.queueSync();
        });
        this.observer.observe(this.root, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-checked'] });
        customElements.whenDefined('variant-picker').then(this.queueSync);
        this.queueSync();
      }

      sizeOf(value) {
        const match = String(value || '').match(/^\s*(3|5|10)\s*ml(?:\s+decant)?\s*$/i);
        return match ? Number(match[1]) : 0;
      }

      currentVariant() {
        const id = this.root.querySelector('.js-product-form [name="id"]')?.value;
        return this.variants.find(variant => String(variant.id) === id) || null;
      }

      targetVariant(size) {
        const options = this.current?.options || this.picker.selectedOptions;
        if (!options) return null;
        return this.variants.find(variant => this.sizeOf(variant.options[this.sizeIndex]) === size
          && variant.options.every((value, index) => index === this.sizeIndex || value === options[index]));
      }

      sync() {
        this.picker = this.root.querySelector('variant-picker');
        this.variants = this.picker?.data?.variants;
        if (!Array.isArray(this.variants)) { this.hidden = true; return; }
        this.current = this.currentVariant();
        if (this.dataset.mode === 'guide') {
          let count = 0;
          this.querySelectorAll('[data-size-card]').forEach(card => {
            const size = Number(card.dataset.sizeCard);
            const target = this.targetVariant(size);
            card.hidden = !target;
            if (!target) return;
            count += 1;
            const selected = this.current?.id === target.id;
            const button = card.querySelector('button');
            button.disabled = !target.available;
            button.setAttribute('aria-pressed', String(selected));
            const label = target.available ? this.dataset[selected ? 'selected' : 'choose'].replace('[size]', `${size}ml`) : this.dataset.soldOut;
            if (button.textContent !== label) button.textContent = label;
            card.classList.toggle('is-selected', selected);
          });
          this.hidden = count === 0;
        } else {
          const target = this.targetVariant(10);
          const show = this.current?.available && this.sizeOf(this.current.options[this.sizeIndex]) === 5
            && target?.available && target.price > this.current.price;
          this.hidden = !show;
          if (!show) return;
          let formatter;
          try {
            formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency });
          } catch (error) { this.hidden = true; return; }
          this.querySelector('[data-upgrade-title]').textContent = this.dataset.upgrade.replace('[amount]', formatter.format((target.price - this.current.price) / 100));
          this.querySelector('[data-upgrade-detail]').textContent = this.dataset.upgradeDetail.replace('[price]', formatter.format(target.price / 100));
          this.querySelector('button').disabled = false;
        }
      }

      choose(size) {
        this.sync();
        const target = this.targetVariant(size);
        if (!target?.available) return;
        const value = target.options[this.sizeIndex];
        const group = this.root.querySelector(`[role="radiogroup"][aria-labelledby="option${this.sizeIndex + 1}"]`);
        const swatch = group && Array.from(group.querySelectorAll('[role="radio"]')).find(radio => radio.getAttribute('aria-label') === value);
        this.status.textContent = '';
        if (swatch) {
          (swatch.querySelector('.swatch-selector') || swatch).click();
          this.queueSync();
          return;
        }
        const selector = this.picker.optionSelectors?.[this.sizeIndex];
        const input = selector && Array.from(selector.querySelectorAll('input[type="radio"]')).find(option => option.value === value);
        if (input) { input.click(); return; }
        const dropdownOption = selector && Array.from(selector.querySelectorAll('.custom-select__option')).find(option => option.dataset.value === value);
        const dropdown = dropdownOption?.closest('custom-select');
        if (dropdown && typeof dropdown.selectOption === 'function') { dropdown.selectOption(dropdownOption); return; }
        this.status.textContent = this.dataset.selectionHelp;
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.root?.removeEventListener('on:variant:change', this.queueSync);
        this.root?.removeEventListener('change', this.queueSync);
        this.observer?.disconnect();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
